import { Overlay as OverlayPrimitive } from "@radix-ui/react-dialog";
import { type ComponentProps } from "react";

import { cn } from "../../utils";

export type DialogOverlayProps = ComponentProps<typeof OverlayPrimitive>;

const Overlay = ({ ref, className, ...props }: DialogOverlayProps) => (
  <OverlayPrimitive
    ref={ref}
    className={cn(
      "fixed inset-0 z-50 bg-neutral-30/40 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
      className
    )}
    {...props}
  />
);

Overlay.displayName = OverlayPrimitive.displayName;

export default Overlay;
